import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth, usePrefs } from "@/lib/context";
import { useCategories, catName } from "@/lib/hooks";
import { PageHeader, StatusBadge } from "@/components/common";
import { PhotoUpload } from "@/components/PhotoUpload";
import { Field } from "@/components/PropertyDialog";
import { ProviderBanner } from "@/pages/Tickets";

export default function ProviderProfile() {
  const { user, setUser } = useAuth();
  const { t, lang } = usePrefs();
  const cats = useCategories();
  const [f, setF] = useState({ trades: user.trades || [], company: user.company || "", phone: user.phone || "", docs: (user.documents || []).map((d) => d.path) });
  useEffect(() => { api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {}); }, [setUser]);
  const toggle = (k) => setF({ ...f, trades: f.trades.includes(k) ? f.trades.filter((x) => x !== k) : [...f.trades, k] });
  const save = async () => {
    try {
      const { data } = await api.put("/me/provider", { trades: f.trades, company: f.company, phone: f.phone, documents: f.docs.map((p) => ({ path: p, name: p.split("/").pop() })) });
      setUser(data);
      toast.success(t("save"));
    } catch (e) { toast.error(errMsg(e)); }
  };
  const status = user.provider_status || "pending";
  return (
    <div className="max-w-3xl" data-testid="provider-page">
      <PageHeader eyebrow={t("role_prestataire")} title={t("provider")}>
        <StatusBadge value={status} label={t(status === "pending" ? "pendingV" : status)} testId="provider-own-status" />
      </PageHeader>
      <ProviderBanner />
      <div className="space-y-6 rounded-sm border border-slate-200 bg-white p-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label={t("company")}><Input value={f.company} onChange={(e) => setF({ ...f, company: e.target.value })} data-testid="provider-company-input" /></Field>
          <Field label={t("phone")}><Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="provider-phone-input" /></Field>
        </div>
        <Field label={t("trades")}>
          <div className="grid gap-2 sm:grid-cols-2">
            {cats.trade.map((c) => (
              <label key={c.key} className="flex items-center gap-2 text-sm"><Checkbox checked={f.trades.includes(c.key)} onCheckedChange={() => toggle(c.key)} data-testid={`provider-trade-${c.key}`} />{catName(c, lang)}</label>
            ))}
          </div>
        </Field>
        <Field label={t("documents")}><PhotoUpload value={f.docs} onChange={(v) => setF({ ...f, docs: v })} testId="provider-doc-upload" /></Field>
        <Button onClick={save} className="rounded-sm bg-[#0F172A] hover:bg-[#B8860B]" data-testid="provider-save-button">{t("save")}</Button>
      </div>
    </div>
  );
}
